/// <reference lib="webworker" />
const SharedWorkerSupported = 'SharedWorkerGlobalScope' in self;
let ports = [];
/**
 * 获取当前的全部端口，如果是非 SharedWorker 环境，则返回一个包含 self 的数组
 * @returns
 */
export const getPorts = () => {
    return ports;
};
/**
 * 对 self.onconnect 事件的封装，内部处理 worker 心跳检测
 * @warning 此方法会自动在 worker 和页面之间发送json格式的消息，内容为 `{ type: 'pong' }`，请确保业务层能够忽略此消息
 */
export const onConnect = (callback) => {
    const ctx = self;
    ctx.onconnect = (e) => {
        const [port] = e.ports;
        ports.push(port);
        const handler = (e) => {
            const { type } = e.data;
            port.pongTime = Date.now();
            if (type === 'unload') {
                port.removeEventListener('message', handler);
                port.messageHandler = undefined;
                ports = ports.filter((p) => p !== port);
            }
            else if (type !== 'pong') {
                /**
                 * 如果不是 pong 格式的消息，统一先响应 pong 消息，告诉页面消息已收到
                 */
                port.postMessage({
                    type: 'pong'
                });
            }
        };
        port.messageHandler = handler;
        port.addEventListener('message', handler);
        callback && callback.call(ctx, e);
    };
    if (!SharedWorkerSupported) {
        ports.push(self);
    }
};
/**
 * 给所有连接的端口广播消息
 * @param message
 */
export const broadcastMessage = (message) => {
    ports.forEach((port) => {
        port.postMessage(message);
    });
};
